import { takeLatest } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import {
  addOtcManualProductSaga,
  addOtcProductSaga,
  addPhysicalInventoryManualRxSaga,
  addPhysicalInventoryManualRxWithoutLotNoSaga,
  addPhysicalInventoryOtcRxProductSaga,
  addPhysicalInventoryOtcRxProductWithoutLotNoSaga,
  addPhysicalInventorySaga,
  addRxProductSaga,
} from "./saga";

export default function* watchInventory() {
  yield takeLatest(
    actionTypes.ADD_PHYSICAL_INVENTORY,
    addPhysicalInventorySaga
  );
  yield takeLatest(
    actionTypes.ADD_PHYSICAL_INVENTORY_MANUAL_RX,
    addPhysicalInventoryManualRxSaga
  );
  yield takeLatest(
    actionTypes.ADD_PHYSICAL_INVENTORY_MANUAL_RX_WITHOUT_LOT_NO,
    addPhysicalInventoryManualRxWithoutLotNoSaga
  );
  yield takeLatest(
    actionTypes.ADD_PHYSICAL_INVENTORY_OTC,
    addPhysicalInventoryOtcRxProductSaga
  );
  yield takeLatest(
    actionTypes.ADD_PHYSICAL_INVENTORY_RX,
    addPhysicalInventoryOtcRxProductSaga
  );
  yield takeLatest(
    actionTypes.ADD_PHYSICAL_INVENTORY_OTC_RX_WITHOUT_LOT_NO,
    addPhysicalInventoryOtcRxProductWithoutLotNoSaga
  );
  yield takeLatest(actionTypes.ADD_OTC_PRODUCT, addOtcProductSaga);
  yield takeLatest(actionTypes.ADD_RX_PRODUCT, addRxProductSaga);
  yield takeLatest(actionTypes.ADD_OTC_MANUAL_PRODUCT, addOtcManualProductSaga);
}
